import React from 'react';
import { RequestIdTableCell } from '../../components/utilities/Table/RequestIdTableCell';
import { RedirectTableCell } from '../../components/utilities/Table/RedirectTableCell';
import AmountGeneralRequest from '../../components/utilities/Table/generalColumns/AmountGeneralRequest';

const requestsListStatusEmployees = [
    {
        id: 'bolsa_general_desembolso',
        label: 'BOLSA GENERAL',
        status: 60,
        responsable: false,
        columns: [
            {
                Header: () => 'Crédito',
                id: 'id',
                typeId: 'HeaderRequest',
                Cell: ({ row }) => {
                    return (
                        <RequestIdTableCell
                            row={row}
                            comparativeDateField={'created_at'}
                        />
                    );
                },
            },
            {
                Header: 'Fecha Creación',
                accessor: 'created_at',
            },
            {
                Header: 'Producto',
                accessor: 'empleado_credito_producto.label',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                Footer: 'Cliente',
            },
            AmountGeneralRequest({
                id: 'monto_aprobado',
                Header: 'Monto Aprobado',
                accessor: 'monto_aprobado',
            }),
            {
                Header: 'Estado',
                accessor: 'estado_credito.label',
            },
            {
                Header: 'Usuario',
                accessor: 'usuario_creacion.name',
            },
        ],
        buttonAction: [{ name: 'takeRequest' }],
    },
    {
        id: 'en_proceso_desembolso',
        label: 'EN PROCESO',
        status: 60,
        responsable: true,
        columns: [
            {
                Header: () => 'Crédito',
                id: 'id',
                Cell: ({ row }) => {
                    return (
                        <RequestIdTableCell
                            row={row}
                            comparativeDateField={'created_at'}
                        />
                    );
                },
            },
            {
                Header: 'Fecha Creación',
                accessor: 'created_at',
            },
            {
                Header: 'Producto',
                accessor: 'empleado_credito_producto.label',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                Footer: 'Cliente',
            },
            AmountGeneralRequest({
                id: 'monto_aprobado',
                Header: 'Monto Aprobado',
                accessor: 'monto_aprobado',
            }),
            {
                Header: 'Estado',
                accessor: 'estado_credito.label',
            },
            {
                Header: 'Usuario',
                accessor: 'usuario_creacion.name',
            },
        ],
    },
    {
        id: 'procesadas_desembolso',
        label: 'PROCESADAS',
        responsable: false,
        nameColumnProcessed: [
            {
                name: 'estado_credito',
                value: 80,
                operator: '%26',
            },
            {
                name: 'usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
            {
                name: 'estado_credito',
                value: 90,
                operator: '|',
            },
        ],
        columns: [
            {
                Header: () => 'Crédito',
                id: 'id',
                Cell: ({ row }) => {
                    return (
                        <RequestIdTableCell
                            row={row}
                            comparativeDateField={'created_at'}
                        />
                    );
                },
            },
            {
                Header: 'Fecha Creación',
                accessor: 'created_at',
            },
            {
                Header: 'Producto',
                accessor: 'empleado_credito_producto.label',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                Footer: 'Cliente',
            },
            AmountGeneralRequest({
                id: 'monto_aprobado',
                Header: 'Monto Aprobado',
                accessor: 'monto_aprobado',
            }),
            {
                Header: 'Estado',
                accessor: 'estado_credito.label',
            },
            {
                Header: 'Usuario',
                accessor: 'usuario_creacion.name',
            },
        ],
        buttonAction: [{ name: 'resumeStatusRequest' }],
    },
];

export default requestsListStatusEmployees;
